import { API_URL, jwtToken } from "../../../context/appContext";
export default async function cancelOrderAndUpdate(id, orderData) {
    return fetch(`${API_URL}/api/order_process/${id}/cancel_update`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + jwtToken
        },
        body: JSON.stringify(orderData)
    })
        .then(res => res.json())
        .then(res => res)
        .catch(err => console.log({ err }))
}
